//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { hasRightsByCreationSource } from '@legacy-components/common/universal-image-actions/checkItemRightsStatus';
import { RightsCreationSource } from 'app/models/RightsCreationSource';
import universalImageActionsFanreelButtonsTemplate from '@legacy-components/common/universal-image-actions/universal-image-actions-fanreel-buttons.html';

(function() {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsFanreelButtons', [
    '$q',
    '$state',
    'ErrorNotificationService',
    'FanreelService',
    'ProductTaggingService',
    'RightsStatus',
    'SessionVarsService',
    'SyndicationService',
    'TrackingService',
    'UniversalImageActionsApiService',
    'UniversalImageActionsService',
    'UniversalImageActionsHelpers',
    'UniversalImageActionsItemType',
    'UniversalImageActionsView',
    'UniversalItemId',
    function(
            $q,
            $state,
            ErrorNotificationService,
            FanreelService,
            ProductTaggingService,
            RightsStatus,
            SessionVarsService,
            SyndicationService,
            TrackingService,
            UniversalImageActionsApiService,
            UniversalImageActionsService,
            UniversalImageActionsHelpers,
            UniversalImageActionsItemType,
            UniversalImageActionsView,
            UniversalItemId,
        ) {
      return {
        restrict: 'E',
        scope: {},
        template: universalImageActionsFanreelButtonsTemplate,
        link(scope) {
          const launchOptions = UniversalImageActionsService.getCurrentLaunchOptions();
          const workflow = UniversalImageActionsService.getCurrentWorkflow();
          const rightsRequestState = UniversalImageActionsView.RightsRequest.name;
          const TRACKING_CATEGORY = UniversalImageActionsHelpers.getTrackingCategory(UniversalImageActionsService.getCurrentPage());
          const singularFanreelName = SessionVarsService.isFeatureEnabled('galleries') ? 'Gallery' : 'Fanreel';
          let itemMetadata;

          scope.model = {
            customRightsRequest: UniversalImageActionsService.getCustomRightsRequest(),
            itemType: launchOptions.getItemType(),
            outstandingAsyncAction: null,
            rightsRejected: true,
            isRightsManaged: false,
            rightsApproved: false,
            isApprovedToReel: false,
          };

          function buildApproveExistingItemArgs(rightsRequest) {
                        // The approve for Fanreel API expects product data to be in a certain shape.
            const products = _(ProductTaggingService.getProducts()).map((p) => {
              return {
                productId: p.externalId,
                styleId: p.productStyleId,
              };
            });

            return {
              reelItemId: launchOptions.getItemId(),
              cuid: launchOptions.getUniversalItemId(),
              tags: UniversalImageActionsService.getReelTags(),
              products,
              rightsRequestText: rightsRequest ? rightsRequest.rightsRequestText : null,
              approvalPhrase: rightsRequest ? rightsRequest.approvalPhrase : null,
              imageAltText: null, // TODO: UIA - What does this mean?
              bypassRightsRequest: !UniversalImageActionsService.itemSupportsRightsRequests() ||
                                (rightsRequest && rightsRequest.bypassRightsRequest),
            };
          }

          function buildApproveNewItemArgs(customRightsRequest) {
                        // The 'cuid' field is only used for USS-based Fanreels and the field is expected to contain the root network item metadata.
                        // So, if we have a sourceNetwork and networkIdentifier from the UIA metadata, then use that to build our partial cuid.
                        // MIS however is not a proper sourceNetwork, so we need to handle that case specially.
            let itemCuid = launchOptions.getUniversalItemId();
            if (itemMetadata.sourceNetwork && itemMetadata.networkIdentifier) {
              itemCuid = new UniversalItemId(itemMetadata.sourceNetwork.toLowerCase(), itemMetadata.networkIdentifier);
            } else if (itemMetadata.networkIdentifier && itemMetadata.networkIdentifier.indexOf('mis_') === 0) {
              itemCuid = new UniversalItemId('media-import', itemMetadata.networkIdentifier);
            }

            const postData = {
              cuid: itemCuid.toString(),
              imageUrl: UniversalImageActionsService.getCanonicalImageUrl(),
              videoUrl: itemMetadata.videoSource,
              lowQualityVideoUrl: itemMetadata.lowQualityVideoSource,
              videoServiceId: itemMetadata.videoServiceId,
              sourceNetwork: itemMetadata.sourceNetwork,
              networkIdentifier: itemMetadata.networkIdentifier,
              universalItemId: launchOptions.getUniversalItemId(),
              tags: UniversalImageActionsService.getReelTags(),
              moderationStatus: (customRightsRequest && !customRightsRequest.bypassRightsRequest) ?
                                FanreelService.MODERATION_STATUS_PENDING : FanreelService.MODERATION_STATUS_APPROVED,
              rightsRequestText: customRightsRequest ? customRightsRequest.rightsRequestText : null,
              approvalPhrase: customRightsRequest ? customRightsRequest.approvalPhrase : null,
              bypassRightsRequest: !UniversalImageActionsService.itemSupportsRightsRequests() ||
                                (customRightsRequest && customRightsRequest.bypassRightsRequest),
              socialDetails: _(itemMetadata.socialDetails || {}).extend({ networkUrl: itemMetadata.originalUrl }),
            };

            postData.productStyleIds = _(ProductTaggingService.getProducts()).map((p) => { return p.productStyleId; });

            return postData;
          }

          scope.model.itemSupportsRightsRequests = function() {
            return UniversalImageActionsService.itemSupportsRightsRequests();
          };

          scope.model.fanreelButtonsDisabled = function() {
            const rightsNotApprovedAndOnRightsPage = !scope.model.rightsApproved &&
                            !scope.model.customRightsRequest &&
                            scope.model.onRightsRequestPage();

            const rightsRejectedAndNotBypassed = scope.model.rightsRejected &&
                            (!scope.model.customRightsRequest || (scope.model.customRightsRequest && !scope.model.customRightsRequest.bypassRightsRequest));

                        // For non-@mentioned items, disable when we have initiated rights yet via copy + paste.
            const rightsNotInitiatedForNonMentionedItem = scope.model.isNetworkInstagramOrFacebook &&
                            scope.model.isRightsManaged &&
                            !scope.model.rightsInitiated &&
                            scope.model.rightsStatus === RightsStatus.Unsent &&
                            !scope.model.automaticRightsRequestCapable;

                        // We can't request rights because this acount doesn't have a facebook business profile connected.
            const brandMentionedInCaptionButNoBusinessAccount = scope.model.automaticRightsRequestCapable &&
                            scope.model.isNetworkInstagramOrFacebook &&
                            !scope.instagramBusinessId;

            // We couldn't find a profile link for this item.
            const rightsItemMissingPostLink = itemMetadata.socialNetwork === 'Instagram' &&
                            itemMetadata.socialDetails.postType === 'Post' &&
                            !itemMetadata.originalUrl;

            const rightsGrantedByRelationship = hasRightsByCreationSource(itemMetadata);

            return scope.model.outstandingAsyncAction !== null ||
                            (rightsRejectedAndNotBypassed ||
                            rightsNotApprovedAndOnRightsPage ||
                            rightsNotInitiatedForNonMentionedItem ||
                            rightsItemMissingPostLink ||
                            brandMentionedInCaptionButNoBusinessAccount) &&
                            !scope.model.bypassRightsRequest &&
                            !scope.model.rightsRejected &&
                            !rightsGrantedByRelationship;
          };

          scope.model.onRightsRequestPage = function() {
            return workflow.getCurrentState() === rightsRequestState;
          };

          const rightsRequestSupported = () => {
            return scope.model.itemSupportsRightsRequests() && scope.model.isRightsManaged;
          };

          const rightsPendingOrInitiated = () => {
            return scope.model.rightsStatus === RightsStatus.Pending ||
                            scope.model.rightsStatus === RightsStatus.Initiated;
          };

          const requestsSupportedAndNotPending = () => {
            return rightsRequestSupported() && !rightsPendingOrInitiated();
          };

                    // Returns button text for Instagram/Facebook items.
          scope.instagramButtonTextToRightsPage = () => {
            if (requestsSupportedAndNotPending() &&
                            scope.model.automaticRightsRequestCapable &&
                            !scope.model.bypassRightsRequest) {
                            // Rights haven't been requested yet + we can directly request on the item.
              return `Request Rights and Approve for ${singularFanreelName}`;
            } else if (scope.model.bypassRightsRequest) {
              return `Skip Rights and Approve for ${singularFanreelName}`;
            } else {
                            // Rights are either already requested or we can't directly request rights on this item.
              return `Approve for ${singularFanreelName}`;
            }
          };

                    // Returns button text for Twitter and other network items.
          scope.defaultButtonTextToRightsPage = () => {
            if (!scope.model.onRightsRequestPage() &&
                            requestsSupportedAndNotPending() &&
                            !scope.model.rightsApproved) {
                            // This is the button shown on the first three steps of Fanreel workflow.
              return 'Request Rights';
            } else if (!scope.model.bypassRightsRequest && requestsSupportedAndNotPending()) {
                            // Show when rights haven't been requested yet.
              return `Request Rights and Approve for ${singularFanreelName}`;
            } else if (scope.model.bypassRightsRequest) {
                            // We're bypassing, so don't show any rights-related text.
              return `Skip Rights and Approve for ${singularFanreelName}`;
            } else {
              return `Approve for ${singularFanreelName}`;
            }
          };

          scope.model.sendGraphRightsRequest = (approveCallback) => {
            const itemId = launchOptions.getUniversalItemId();
            const params = {
              requestForRightsMessage: _(scope).safeGet('model.customRightsRequest.rightsRequestText'),
              approvalPhrase: _(scope).safeGet('model.customRightsRequest.approvalPhrase'),
            };
            scope.model.outstandingAsyncAction = 'sendGraphRightsRequest';
            return UniversalImageActionsService.sendRightsRequest(itemId, params, TRACKING_CATEGORY).then((rightsRequestFailed) => {
              if (approveCallback) {
                approveCallback(!rightsRequestFailed /* closeWhenComplete */, true /* rightsAlreadyRequested */);
              }
              scope.model.outstandingAsyncAction = null;
            });
          };

          scope.model.sendRequestAndApprove = () => {
            if (scope.model.bypassRightsRequest) {
              scope.model.approve(true /* closeWhenComplete */, false /* rightsAlreadyRequested */);
            } else if (scope.model.automaticRightsRequestCapable && scope.model.isNetworkInstagramOrFacebook) {
              scope.model.sendGraphRightsRequest(scope.model.approve);
            } else if (scope.model.rightsInitiated) {
              scope.model.approve(true /* closeWhenComplete */, true /* rightsAlreadyRequested */);
            } else {
              scope.model.approve(true /* closeWhenComplete */, false /* rightsAlreadyRequested */);
            }
          };

          scope.model.isRightsRequestDone = () => {
            return scope.model.isApprovedToReel &&
                            !scope.model.rightsRejected &&
                            scope.model.rightsStatus !== RightsStatus.Unsent &&
                            !scope.model.bypassRightsRequest;
          };

          scope.model.approve = function(closeWhenComplete, rightsAlreadyRequested) {
            const selectedReel = UniversalImageActionsService.getSelectedReel();
            const rightsGrantedByRelationship = hasRightsByCreationSource(itemMetadata);

            const approvalCompletePromise = UniversalImageActionsService.getSelectedReelMetadataAsync().then((metadata) => {
                            /* eslint consistent-return: off */ // TODO: someone who knows what's going on here... fix me
              let args;

              if (metadata.isRightsManaged) {
                if (
                                    UniversalImageActionsService.itemSupportsRightsRequests() &&
                                    (workflow.getCurrentState() !== rightsRequestState) &&
                                    !scope.model.rightsApproved
                                ) {
                  workflow.goToState(rightsRequestState);
                  $state.go(`^.${rightsRequestState}`);
                  return;
                }
              }

                            // If the item is a fanreel item being approved for its own reel, mark it as approved in the reels database
                            // Otherwise, add it to the selected reel as a pre-approved item
                            // TODO: call .toLowerCase on the reel_ids here until everything is normalized in DEV-10839
              if (rightsGrantedByRelationship) {
                args = buildApproveNewItemArgs({});
                return FanreelService.addItemAsync(selectedReel.id, args);
              } else if (rightsAlreadyRequested && !scope.model.bypassRightsRequest) {
                return FanreelService.approveItemWithoutRightsAsync(selectedReel.id, buildApproveNewItemArgs());
              } else if (
                                scope.model.itemType.toLowerCase() === UniversalImageActionsItemType.fanreel &&
                                itemMetadata.reelId.toLowerCase() === selectedReel.id.toLowerCase()
                            ) {
                if (metadata.isRightsManaged && !scope.model.rightsApproved) {
                  args = buildApproveExistingItemArgs(scope.model.customRightsRequest);
                } else {
                  args = buildApproveExistingItemArgs({});
                }

                scope.model.outstandingAsyncAction = 'approveForFanreel';
                return FanreelService.approveItemAsync(selectedReel.id, args);
              } else {
                if (metadata.isRightsManaged && !scope.model.rightsApproved) {
                  args = buildApproveNewItemArgs(scope.model.customRightsRequest);
                } else {
                  args = buildApproveNewItemArgs({});
                }
                scope.model.outstandingAsyncAction = 'approveForFanreel';
                return FanreelService.addItemAsync(selectedReel.id, args);
              }
            });

                        // This promise will be defined only if we've invoked "FanreelService.addItem/approveItem"
            approvalCompletePromise.then((result) => {
              let action;
              let label = '';
              let actionCompleted = '';

              if (result) {
                const toastArgs = {
                  message: `Successfully sent image to your ${singularFanreelName}` +
                                        `${selectedReel ? `: ${selectedReel.name || selectedReel.id}` : ''}!`,
                };

                if (scope.model.itemType === UniversalImageActionsItemType.syndication) {
                  SyndicationService.saveUserImageActivity(launchOptions.getItemId(), 'approveForFanreel');
                }

                if (!result.bypassRightsRequest) {
                  action = TrackingService.ACTION_REQUESTED_RIGHTS;
                  label = `message=${result.rightsRequestText ? 'custom' : 'default'}`;
                  label += ',context=approve-for-fanreel';
                  actionCompleted = TrackingService.ACTION_REQUESTED_RIGHTS;
                } else {
                  action = TrackingService.ACTION_APPROVE_FOR_FANREEL;
                  actionCompleted = TrackingService.ACTION_APPROVE_FOR_FANREEL;
                }

                TrackingService.recordEvent(TRACKING_CATEGORY, action, label);

                scope.model.itemModerationStatus = result.moderationStatus;

                if (scope.model.itemModerationStatus === 'approved') {
                  scope.model.isApprovedToReel = true;
                  UniversalImageActionsService.bypassRightsRequest.next(false);
                }

                scope.model.closeObject = {
                  result: {
                    itemWasApprovedForFanreel: true,
                    actionCompleted,
                    successToast: toastArgs,
                  },
                };

                if (closeWhenComplete) {
                  scope.model.close();
                }
              }
            }).catch((error) => {
              if (error.message) {
                ErrorNotificationService.showDefaultErrorDialog(error.message, error);
              } else {
                ErrorNotificationService.showDefaultErrorDialog(error);
              }
            }).finally(() => {
              scope.model.outstandingAsyncAction = null;
            });
          };

          scope.model.close = function() {
            scope.$emit('uia:modal:close', scope.model.closeObject);
          };

          const refreshIsApprovedToReel = () => {
            FanreelService.getIsItemInReel(
                            UniversalImageActionsService.getSelectedReel().id,
                            launchOptions.getUniversalItemId(),
                        ).then((result) => {
                          scope.model.isApprovedToReel = result;
                        });
          };

          const getRightsStatus = () => {
            UniversalImageActionsService.getRightsRequestAsync().then((r) => {
              if (r.status !== RightsStatus.Rejected) {
                scope.model.rightsRejected = false;
              }

              if (r.status === RightsStatus.Approved) {
                scope.model.rightsApproved = true;
              }

              if (r.status === RightsStatus.Initiated || r.status === RightsStatus.Pending) {
                scope.model.rightsInitiated = true;
              }
            });

            scope.model.rightsStatus = _(itemMetadata).safeGet('rightsRequestStatus.status');
          };

                    //
                    // Initialization
                    //
          scope.model.outstandingAsyncAction = 'init';
          $q.all([
            UniversalImageActionsService.getItemMetadataAsync(),
            UniversalImageActionsService.getCachedReelsAsync(),
            UniversalImageActionsService.getSelectedReelMetadataAsync(),
            UniversalImageActionsService.getInstagramBusinessId(),
          ]).then((results) => {
            const reelMetadata = results[2];
            itemMetadata = results[0];
            scope.instagramBusinessId = _(results[3]).safeGet('businessId');

            getRightsStatus();

            scope.model.isRightsManaged = reelMetadata && reelMetadata.isRightsManaged;

            scope.model.isNetworkInstagramOrFacebook = itemMetadata.sourceNetwork &&
                            (itemMetadata.sourceNetwork.toLowerCase() === UniversalImageActionsItemType.facebook ||
                             itemMetadata.sourceNetwork.toLowerCase() === UniversalImageActionsItemType.instagram);
          }).then(() => {
            refreshIsApprovedToReel();
          }).finally(() => {
            scope.model.outstandingAsyncAction = null;
          });

          scope.$on('uia:modal:selected-reel-changed', () => {
            UniversalImageActionsService.getSelectedReelMetadataAsync().then((metadata) => {
              scope.model.isRightsManaged = metadata.isRightsManaged;
              UniversalImageActionsService.bypassRightsRequest.next(false);
            });
            refreshIsApprovedToReel();
          });

          scope.$on('uia:modal:rights-request-changed', ($event, newVal) => {
            scope.model.customRightsRequest = newVal;
          });

          UniversalImageActionsService.getInstagramRequestStatus().subscribe((status) => {
            scope.model.rightsInitiated = status === RightsStatus.Initiated || status === RightsStatus.Pending;
            scope.model.rightsRequestStatus = status;
          });

          UniversalImageActionsService.bypassRightsRequest.subscribe((bypassed) => {
            scope.model.bypassRightsRequest = bypassed;
          });

          UniversalImageActionsService.getAutomaticRightsRequestCapable().subscribe((isCapable) => {
            scope.model.automaticRightsRequestCapable = isCapable;
          });
        },
      };
    },
  ]);
})();
